import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { MODEL_FAMILY_TYPES } from '@/types';

interface LlmModelFamilyFieldProps {
  value: MODEL_FAMILY_TYPES | null;
  setValue: (value: MODEL_FAMILY_TYPES | null) => void;
}

function LlmModelFamilyField({
  value,
  setValue,
}: LlmModelFamilyFieldProps): React.JSX.Element {
  return (
    <FormControl fullWidth>
      <InputLabel id='llm-model-family-label'>LLM Model Family</InputLabel>
      <Select
        labelId='llm-model-family-label'
        label='LLM Model Family'
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value;
          setValue(v ? (v as MODEL_FAMILY_TYPES) : null);
        }}
      >
        <MenuItem value=''>
          <em>None</em>
        </MenuItem>
        {Object.values(MODEL_FAMILY_TYPES).map((model_family) => (
          <MenuItem key={model_family} value={model_family}>
            {model_family}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LlmModelFamilyField;

